import React from "react";
import refresh from "../../../assets/images/generic/refresh.svg";
var RefreshLabel = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "refreshOuterDiv ".concat(props.parentClassName, " mb-2") }, props.icon ? (React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.mobRefresh) ? (React.createElement("div", { onClick: function () {
                props.onCallBackFunction && props.onCallBackFunction();
            }, className: "hand_cursor image text-center px-1 mt-2" },
            React.createElement("img", { src: refresh }),
            React.createElement("p", { className: "DMSan_14_500 txt_primaryGrey text pt-1 " }, props.title))) : (React.createElement("div", { onClick: function () {
                props.onCallBackFunction && props.onCallBackFunction();
            }, className: "hand_cursor image refresh-align" },
            React.createElement("img", { src: refresh }),
            React.createElement("span", { className: "DMSan_14_500 txt_primaryGrey text  lineHeightmb30" },
                "\u00A0",
                props.title))))) : (React.createElement("span", { className: "DMSan_14_500 txt_primaryGrey text ps-0 mb-2" }, props.title)))));
};
export default RefreshLabel;
